
const REFRAL_CONTACT_STATUS_OPTIONS = [
    { label: 'Pending', value: 0 },
    { label: 'Approved', value: 1 },
    // { label: 'Rejected', value: 'rejected' },
];

const REFRAL_REQUEST_STATUS_OPTIONS = [
    { label: 'Pending', value: 'pending' },
    { label: 'Approved', value: 'approved' },
    { label: 'Rejected', value: 'rejected' },
];

const STATUS_OPTIONS = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' },
];

const STATUS_BOOLEAN_OPTIONS = [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
];

const STATUS_INVOICE_OPTIONS = [
    { label: 'Billable', value: 'billable' },
    { label: 'Billed', value: 'billed' },
    { label: 'Paid', value: 'paid' },
    { label: 'Not Billable', value: 'not billable' },
];

const STATUS_INVOICE_LISTING_OPTIONS = [
    { label: 'Billed', value: 'billed' },
    { label: 'Approved', value: 'approved' },
    { label: 'Pending', value: 'pending' },
    { label: 'Paid', value: 'paid' },
    { label: 'Partially Paid', value: 'partially_paid' },
];

const PAYMENT_INVOICE_LISTING_OPTIONS = [
    { label: 'Billed', value: 'billed' },
    { label: 'Approved', value: 'approved' },
    { label: 'Pending', value: 'pending' },
    { label: 'Paid', value: 'paid' },
];

const MATTER_STATUS_OPTIONS = [
    { label: 'Open', value: 'open' },
    { label: 'Closed', value: 'closed' },
    { label: 'Pending', value: 'pending' },
    { label: 'Archived', value: 'archived' },
];

const TYPE_OPTIONS = [
    { label: 'User', value: 'user' },
    { label: 'Matter', value: 'matter' },
    { label: 'Contact', value: 'contact' }
]

const FIELD_TYPE_OPTIONS = [
    { label: 'Text', value: 'text' },
    { label: 'Dropdown', value: 'dropdown' },
    { label: 'Date', value: 'date' },
    { label: 'Checkbox', value: 'checkbox' },
    { label: 'Radio', value: 'radio' }
]

const STATUS_NUMBER_OPTIONS = [
    { label: 'Enabled', value: 1 },
    { label: 'Disabled', value: 0 }
];

const STATUS_ACTIVE_NUMBER_OPTIONS = [
    { label: 'Active', value: 1 },
    { label: 'Inactive', value: 0 }
];

const YES_NO_NUMBER_OPTIONS = [
    { label: 'Yes', value: 1 },
    { label: 'No', value: 0 },
  ];

export { 
    REFRAL_REQUEST_STATUS_OPTIONS,
    REFRAL_CONTACT_STATUS_OPTIONS,
    STATUS_OPTIONS, 
    TYPE_OPTIONS, 
    STATUS_NUMBER_OPTIONS, 
    FIELD_TYPE_OPTIONS, 
    YES_NO_NUMBER_OPTIONS, 
    MATTER_STATUS_OPTIONS,
    STATUS_BOOLEAN_OPTIONS,
    STATUS_INVOICE_OPTIONS,
    STATUS_INVOICE_LISTING_OPTIONS,
    STATUS_ACTIVE_NUMBER_OPTIONS,
    PAYMENT_INVOICE_LISTING_OPTIONS,
}